module.exports = __webpack_public_path__ + "img/PINK-alt.cdc346aa.svg";